import { render, staticRenderFns } from "./Dashboard2.vue?vue&type=template&id=168d7391&scoped=true&"
import script from "./Dashboard2.vue?vue&type=script&lang=ts&"
export * from "./Dashboard2.vue?vue&type=script&lang=ts&"
import style0 from "./Dashboard2.vue?vue&type=style&index=0&id=168d7391&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "168d7391",
  null
  
)

export default component.exports